import { Global } from "@emotion/react";

export function FontCss() {
  return (
    <Global
      styles={`
        @font-face {
          font-family: 'Fira Sans';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('/fonts/FiraSans-Regular.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Sans';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: url('/fonts/FiraSans-Medium.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Sans';
          font-style: normal;
          font-weight: 600;
          font-display: swap;
          src: url('/fonts/FiraSans-SemiBold.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Sans';
          font-style: italic;
          font-weight: 400;
          font-display: swap;
          src: url('/fonts/FiraSans-Italic.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Sans';
          font-style: italic;
          font-weight: 600;
          font-display: swap;
          src: url('/fonts/FiraSans-SemiBoldItalic.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Mono';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('/fonts/FiraMono-Regular.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Mono';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: url('/fonts/FiraMono-Medium.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Fira Mono';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('/fonts/FiraMono-Bold.woff2') format('woff2');
        }
      `}
    />
  );
}

export default {
  body: "'Fira Sans', sans-serif",
  heading: "'Fira Sans', sans-serif",
  mono: "'Fira Mono', monospace",
};
